"use client";

import { useEffect, useRef } from 'react';
import { clearDashboardCache } from './dashboardCache';

export function DashboardCacheListener() {
  const lastClearTimeRef = useRef<number>(0);

  useEffect(() => {
    const checkForClearFlag = () => {
      const clearFlag = localStorage.getItem('clear_dashboard_cache');
      if (clearFlag) {
        const clearTime = parseInt(clearFlag, 10);
        if (clearTime > lastClearTimeRef.current) {
          console.log('[Dashboard] Detected clear_dashboard_cache flag, clearing cache');
          lastClearTimeRef.current = clearTime;
          clearDashboardCache('/api/batch');
          localStorage.removeItem('clear_dashboard_cache');
          console.log('[Dashboard] Cache cleared and flag removed');
        }
      }
    };

    checkForClearFlag();

    const handleClearEvent = () => {
      console.log('[Dashboard] Received clear-dashboard-cache event');
      console.log('[Dashboard] Clearing all dashboard cache');
      clearDashboardCache('/api/batch');
      console.log('[Dashboard] All dashboard cache cleared');
    };

    window.addEventListener('clear-dashboard-cache', handleClearEvent);

    const interval = setInterval(checkForClearFlag, 1000);

    return () => {
      window.removeEventListener('clear-dashboard-cache', handleClearEvent);
      clearInterval(interval);
    };
  }, []);

  return null;
}
